import { useContext } from 'react';
import { IFileUploadContext } from '../models/fileUpload';
import { FileUploadContext } from '../providers/FileUploadProvider';

export const useFileUploadContext = (): IFileUploadContext => useContext(FileUploadContext);
